import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { useCompanyPageStore } from "../../../store/companyPageStore";
import Grid from "@mui/material/Grid";
import { TopVendorsByProducts } from "./components/Install/Installs/TopVendorsByProducts";
import { VendorsByCategory } from "./components/Install/Installs/VendorsByCategory";
import { InstallsByCountry } from "./components/Install/Installs/InstallsByCountry";
import { IntensityTrend } from "./components/Install/Intensity/IntensityTrend";
import { IntensityMomentum } from "./components/Install/Intensity/IntensityMomentum";
import { ProductInstalls } from "./components/Install/Installs/ProductInstalls";
import { FaiByDepartment } from "./components/Install/FAI/FaiByDepartment";
import { FaiByProduct } from "./components/Install/FAI/FaiByProduct";
import { IntensityOverTime } from "./components/Install/Intensity/IntensityOverTime";
import { InstallFilters } from "./components/Install/Filters/InstallFilters";

export const InstallView = () => {
  const company = useCompanyPageStore((state) => state.company);

  if (!company) return null;

  return (
    <Box>
      <Divider sx={{ my: 1 }} />
      <Grid container spacing={3}>
        <Grid size={12}>
          <InstallFilters />
        </Grid>
        <Grid size={12}>
          <ProductInstalls />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <FaiByDepartment />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <FaiByProduct />
        </Grid>
        <Grid size={12}>
          <InstallsByCountry />
        </Grid>
        <Grid size={12}>
          <VendorsByCategory />
        </Grid>
        <Grid size={12}>
          <TopVendorsByProducts />
        </Grid>
        <Grid size={12}>
          <IntensityOverTime />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <IntensityTrend />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <IntensityMomentum />
        </Grid>
      </Grid>
    </Box>
  );
};
